import React, { createContext, useState, useContext } from 'react';

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [paymentSuccessful, setPaymentSuccessful] = useState(false);

  return (
    <PaymentContext.Provider value={{ paymentSuccessful, setPaymentSuccessful }}>
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => useContext(PaymentContext);
